"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShowsContextCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_sds_c_1 = require("@snapchat/web-sds-c");
const ShowsContextCard_module_css_1 = __importDefault(require("./ShowsContextCard.module.css"));
/**
 *
 */
function ShowsContextCard({ publisherDisplayName, episodeInfo }) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: ShowsContextCard_module_css_1.default.contextCard, children: [(0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H4", emphasis: true, tag: "H1", children: (0, jsx_runtime_1.jsx)("span", { className: ShowsContextCard_module_css_1.default.publisherDisplayName, children: publisherDisplayName }) }), (0, jsx_runtime_1.jsx)(web_sds_c_1.Heading, { size: "H6", children: (0, jsx_runtime_1.jsx)("span", { className: ShowsContextCard_module_css_1.default.episodeInfo, children: episodeInfo }) })] }));
}
exports.ShowsContextCard = ShowsContextCard;
//# sourceMappingURL=ShowsContextCard.js.map